import { BackIcon } from "../SvgIcons";
import styles from "./BackToLogin.module.scss";

import { useNavigate } from "react-router-dom";
import { PAGE_URLS } from "@constants/common";

const BackToLogin = () => {
  const navigate = useNavigate();

  const redirection = () => {
    navigate(PAGE_URLS.LOGIN, { replace: true });
  };

  return (
    <div className={styles["back-container"]} onClick={redirection}>
      <BackIcon />
      <span>Back to Login</span>
    </div>
  );
};

export default BackToLogin;
